import { FESTIVAL_TYPE } from "@features/landing/types";
import classNames from "classnames";
import { festivalColors } from "@features/landing/helpers/constants/festival-colors";
import { festivalTexts } from "@features/landing/helpers/constants/festival-texts";
import { toFarsiNumber } from "@utils/digits";
import dynamic from "next/dynamic";
const FestivalCountDown = dynamic(() => import("../countdown"), { ssr: false });

interface Props {
  theme: FESTIVAL_TYPE;
  title: string;
  discountText?: string;
  specialText: string;
  expireDate: number | Date;
}

const HeroRightSide: React.FC<Props> = ({
  theme,
  title,
  discountText,
  expireDate,
  specialText,
}) => {
  const festivalText = discountText
    ? festivalTexts[theme](discountText, specialText, title)
    : "";
  return (
    <div className="lg:w-[510px] lg:basis-[510px] text-white sm:w-[344px] flex flex-col justify-center items-center sm:items-start  z-4 relative">
      <h1
        className={classNames(
          "lg:text-4xl lg:font-semibold  sm:mb-3  sm:display-sm  headline-xlg  mb-2",
          festivalColors[theme].title
        )}
      >
        {toFarsiNumber(title)}
      </h1>
      {Boolean(discountText) && (
        <div className="lg:text-base lg:font-medium lg:leading-6 sm:mb-10 sm:text-right text-center text-sm leading-5 mb-6">
          {festivalText}
        </div>
      )}
      <div className="flex gap-2">
        <FestivalCountDown expireDate={expireDate} theme={theme} />
      </div>
    </div>
  );
};

export default HeroRightSide;
